import { QRCode } from 'antd';
import React, { useEffect, useState } from 'react';

// 1. The Raw Data Object (Can be replaced with props or fetched data later)


// 2. Utility Function to Format UTC Dates to Local Readable String
const formatDate = (utcDateString) => {
    if (!utcDateString) return 'N/A';
    try {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short'
        };
        return date.toLocaleString(undefined, options);
    } catch (e) {
        console.error("Error parsing date:", e);
        return 'Invalid Date';
    }
};

const PdfFormat = ({initialVisitorData}) => {
    // In a real app, this data would likely come from props or an API call
    const data = initialVisitorData;
    const school = data.schoolId || {};

    // Use a state variable for the logo source and handle error gracefully
    const [logoSrc, setLogoSrc] = useState(school.logo || 'https://placehold.co/40x40/cccccc/333333?text=O');
    const fallbackLogo = 'https://placehold.co/40x40/cccccc/333333?text=O';

    return (
        <div className="invite-card-container h-auto w-full" id='visitorPdf'>
           
            <div className="invite-card">
                {/* Header Section */}
                <header className="bg-gray-800 p-6 flex items-center justify-between text-white">
                    <div className="flex items-center space-x-4">
                 
                        <h1 className="text-2xl font-bold tracking-tight">
                            {school.nameOfSchool || 'Office Name'}
                        </h1>
                    </div>
                    <div className="text-center">
                        <p className="text-sm font-light opacity-80">Visitor Invitation Pass</p>
                      
                    </div>
                </header>

                {/* Main Content Grid */}
                <main className="p-8">
                    <h2 className="text-3xl font-extrabold text-gray-900 mb-6">
                        Welcome, <span className="text-indigo-600">{data.visitorName || 'Guest'}</span>
                    </h2>

                    <div className="space-y-8">
                        {/* 1. Visitor Details Section */}
                        <div className="detail-section border-b pb-6 border-gray-200">
                            <h3 className="text-xl font-semibold mb-4 text-gray-700">1. Visitor & Company Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                                <div className="space-y-1">
                                    <p className="label">Visitor Name</p>
                                    <p className="value text-lg">{data.visitorName || 'N/A'}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Company</p>
                                    <p className="value text-lg">{data.company || 'N/A'}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Contact Email</p>
                                    <p className="value">{data.contact || 'N/A'}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Visitor Category</p>
                                    <p className="value">
                                        {data.category ? data.category.charAt(0).toUpperCase() + data.category.slice(1) : 'N/A'}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* 2. Visit Details Section */}
                        <div className="detail-section border-b pb-6 border-gray-200">
                            <h3 className="text-xl font-semibold mb-4 text-gray-700">2. Visit Information</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                                <div className="space-y-1">
                                    <p className="label">Purpose of Visit</p>
                                    <p className="value text-lg text-indigo-600">
                                        {data.purposeOfVisit ? data.purposeOfVisit.charAt(0).toUpperCase() + data.purposeOfVisit.slice(1) : 'N/A'}
                                    </p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Host Employee</p>
                                    <p className="value">{data?.hostEmployee?.firstName || 'N/A'} {data?.hostEmployee?.lastName || ''}</p>
                                </div>
                                {/* <div className="space-y-1">
                                    <p className="label">Check-in Time</p>
                                    <p className="value">{formatDate(data.checkInTime)}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Check-out Time</p>
                                    <p className="value">{formatDate(data.checkOutTime)}</p>
                                </div> */}
                                 <div className="space-y-1">
                                    <p className="label">Scheduled Time</p>
                                    <p className="value">{formatDate(data.scheduledTime)}</p>
                                </div>
                                {/* <div className="space-y-1">
                                    <p className="label">Visit Status</p>
                                    <p className="value uppercase">{data.status || 'N/A'}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">Visit Type</p>
                                    <p className="value capitalize">{data.visitType || 'N/A'}</p>
                                </div> */}
                            </div>
                        </div>

                        {/* 3. Office Location Section */}
                        <div className="detail-section">
                            <h3 className="text-xl font-semibold mb-4 text-gray-700">3. Location Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                                <div className="space-y-1">
                                    <p className="label">Branch</p>
                                    <p className="value text-lg">{school.branchName || 'N/A'}</p>
                                </div>
                                <div className="space-y-1">
                                    <p className="label">City & Country</p>
                                    <p className="value text-lg">{school.city || 'N/A'}</p>
                                </div>
                              
                             
                            </div>
                        </div>
                    </div>
                      <div className="space-y-1 flex flex-row  w-full my-10">
                                    <div className='w-[60%]'>
                                        <p className="label">Address</p>
                                    <p className="value">{school.address || 'N/A'}</p>
                                    </div>
     <div className="bg-white w-auto ">
    <QRCode value="https://officeapp.studentdiwan.com/visitor-management"  size={90} />
                        </div>
                                </div>
                </main>

                {/* Footer Note */}
                <footer className="bg-gray-100 p-6 text-center text-sm text-gray-500 border-t">
                    <p>Please present this invitation upon arrival</p>
                </footer>
            </div>
        </div>
    );
};

export default PdfFormat;
